export function validate(fields, data) {
  let errors = [];

  fields.forEach(field => {
    const result = validateSingle(field, data[field.key]);
    if (result.errors.length > 0) {
      errors = errors.concat(result.errors);
    }
  });

  return {
    valid: errors.length === 0,
    errors,
  };
}

export function validateSingle(field, data) {
  const errors = [];

  if (field.rules) {
    field.rules.forEach(rule => {
      // Required
      if (rule === 'required') {
        if (typeof data === 'undefined' || data === '' || data === null) {
          errors.push(`Field ${field.label} is required`);
        }
      }
      // Spaces
      if (rule === 'nospace') {
        if (/\s/.test(data)) {
          errors.push(
            `Field ${field.label} must not contain whitespace characters`,
          );
        }
      }
    });
  }
  return {
    valid: errors.length === 0,
    errors,
  };
}

export function validateSingleBoolean(field, data) {
  return validateSingle(field, data).valid;
}

/**
 * Alias function for validateSingleBoolean
 * @param {*} field
 * @param {*} data
 */
export function hasErrors(field, data) {
  return validateSingleBoolean(field, data);
}
